// extracted by mini-css-extract-plugin
export var calculatePrice = "calculatePrice-module--calculatePrice--UhSLE";
export var calculatePrice__button = "calculatePrice-module--calculatePrice__button--c-d1N";
export var input_test = "calculatePrice-module--input_test--srvEU";